import { useState } from 'react';

import { TextField, Select, MenuItem, Typography, InputLabel, FormHelperText } from '@mui/material';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { IntegrationTypes } from '../../../../../types/integrationTypes';

const NameLMSRow = styled.div`
    display: flex;
    margin-top: 24px;
    flex-direction: row;
    justify-content: flex-start;
`;

const StyledSelect = styled(Select)`
    width: 400px;
    margin-left: auto;
`;

const StyledLabelFieldDiv = styled.div`
    display: flex;
    flex-direction: column;
`;

const NameField = styled(TextField)`
    width: 400px;
`;

const SelectDiv = styled.div`
    margin-left: 24px;
    display: flex;
    flex-direction: column;
`;

interface NameAndLMSProps {
    title: string;
    type: string;
    handleChange: (event: any) => void;
}

const NameAndLMS: React.FC<NameAndLMSProps> = ({ title, type, handleChange }) => {
    const { t } = useTranslation('admin_settings');
    const [nameError, setNameError] = useState<boolean>(false);
    const [selectError, setSelectError] = useState<boolean>(false);
    console.log('NameAndLMS', title, type);
    const handleNameChange = (event) => {
        const { value } = event.target;
        if (!value.length) {
            setNameError(true);
        } else {
            setNameError(false);
        }
        handleChange(event);
    };

    const handleSelectChange = (event) => {
        const { value } = event.target;
        if (!value.length) {
            setSelectError(true);
        } else {
            setSelectError(false);
        }
        handleChange(event);
    };

    return (
        <NameLMSRow>
            <StyledLabelFieldDiv>
                <Typography>{t('integration-name')}</Typography>
                <NameField
                    name="title"
                    value={title}
                    onChange={handleNameChange}
                    error={nameError}
                    placeholder={t('example-name')}
                    helperText={t('integration-name-helper')}
                    size="small"
                />
            </StyledLabelFieldDiv>
            <SelectDiv>
                <InputLabel id="select-lms-label">{t('lms-name')}</InputLabel>
                <StyledSelect
                    name="type"
                    value={type}
                    label={t('lms-name')}
                    labelId="select-lms-label"
                    error={selectError}
                    onChange={handleSelectChange}
                    size="small"
                >
                    <MenuItem value={IntegrationTypes.Canvas} selected={type == IntegrationTypes.Canvas}>
                        {t('canvas')}
                    </MenuItem>
                    <MenuItem value={IntegrationTypes.Blackboard} selected={type == IntegrationTypes.Blackboard}>
                        {t('blackboard')}
                    </MenuItem>
                    <MenuItem value={IntegrationTypes.CSOD} selected={type == IntegrationTypes.CSOD}>
                        {t('csod')}
                    </MenuItem>
                    <MenuItem value={IntegrationTypes.D2L} selected={type == IntegrationTypes.D2L}>
                        {t('d2l')}
                    </MenuItem>
                    <MenuItem value={IntegrationTypes.Docebo} selected={type == IntegrationTypes.Docebo}>
                        {t('docebo')}
                    </MenuItem>
                    <MenuItem value={IntegrationTypes.Moodle} selected={type == IntegrationTypes.Moodle}>
                        {t('moodle')}
                    </MenuItem>
                    <MenuItem value={IntegrationTypes.OpenLMS} selected={type == IntegrationTypes.OpenLMS}>
                        {t('openlms')}
                    </MenuItem>
                    <MenuItem value={IntegrationTypes.Sakai} selected={type == IntegrationTypes.Sakai}>
                        {t('sakai')}
                    </MenuItem>
                    <MenuItem value={IntegrationTypes.Schoology} selected={type == IntegrationTypes.Schoology}>
                        {t('schoology')}
                    </MenuItem>
                    <MenuItem value={IntegrationTypes.IMS} selected={type == IntegrationTypes.IMS}>
                        {t('ims')}
                    </MenuItem>
                    <MenuItem value={IntegrationTypes.Other} selected={type == IntegrationTypes.Other}>
                        {t('other')}
                    </MenuItem>
                </StyledSelect>
                <FormHelperText>{t('lms-name-helper')}</FormHelperText>
            </SelectDiv>
        </NameLMSRow>
    );
};

export default NameAndLMS;
